export default __webpack_public_path__ + "static/media/office4.19c2a312.png";